import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { UnionService } from 'src/app/services/union.service';
import { Union } from 'src/app/models/union';
import { User } from 'src/app/models/user.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  isCollapsed = true;
  unionData: Union = new Union();
  isLoadingUnion = false;
  currentUser: User | null = null;
  private subscriptions: Subscription[] = [];

  constructor (
    private appService: AppService,
    private authService: AuthService,
    private unionService: UnionService,
    private toastr: ToastrService
  ){ }

  ngOnInit(): void {
    this.loadUnionData();
    this.loadCurrentUser();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private loadUnionData(): void {
    this.isLoadingUnion = true;
    const subscription = this.unionService.getSingleUnion().subscribe({
      next: (response) => {
        this.unionData = response;
        this.isLoadingUnion = false;
      },
      error: (error) => {
        console.error('Error loading union data:', error);
        this.isLoadingUnion = false;
        // Don't show error toast as it's not critical for navbar functionality
      }
    });
    
    this.subscriptions.push(subscription);
  }

  private loadCurrentUser(): void {
    try {
      const userData = localStorage.getItem('user-data');
      if (userData) {
        this.currentUser = JSON.parse(userData);
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      this.currentUser = null;
    }
  }

  getUserDisplayName(): string {
    if (!this.currentUser) return 'User';
    return this.currentUser.username || this.currentUser.email || 'User';
  }

  getUserRole(): string {
    if (!this.currentUser?.roles || this.currentUser.roles.length === 0) {
      return 'User';
    }
    
    // Convert role names to display-friendly format
    const role = this.currentUser.roles[0].toLowerCase();
    if (role === 'admin') return 'Administrator';
    if (role === 'manager') return 'Manager';
    if (role === 'user') return 'User';
    
    // Capitalize first letter for other roles
    return role.charAt(0).toUpperCase() + role.slice(1);
  }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
  }
  
  toggleSidebar() {
    this.appService.toggleSidebar();
  }
  
  goToLoginPage(){
    this.authService.logout();
  }
}
